import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
    root: {
        background: theme.palette.background.paper,
        width: "100%",
        overflow: "hidden",
        borderRadius: "12px",
        border: `1px solid ${theme.palette.grey[theme.palette.mode === "dark" ? 800 : 200]}`,
    },
    headerView: {
        background: theme.palette.blue[6],
        color: theme.palette.common.white,
        display: "flex",
        alignItems: "center",
        padding: theme.spacing(1, 2),
        borderBottom: `1px solid ${theme.palette.grey[theme.palette.mode === "dark" ? 800 : 200]}`,
        height: theme.spacing(7)
    },
}));
